import {Backbone} from 'Vertebrae';
import {User} from '../model/user';

export const Users = Backbone.Collection.extend({
    _name: 'Users',
    url: '/control/partner/users/get.json',
    model: User,
});
